import moment from 'moment';
import applicationEventHub from "../events/applicationEventHub";
export default {
  data(){
    return {
      currentPageState:null,
      stateStarted:null,
      stateEnded:null,
    };
  },
  methods : {
    initPageChecks(){
      document.addEventListener("visibilitychange",this.onVisibilityChange);
      window.addEventListener("blur",this.onBlur);
      window.addEventListener("focus",this.onFocus);
      window.addEventListener("resize",this.onResize);
      applicationEventHub.$on('framework.pause.start', this.onPause);
      applicationEventHub.$on('framework.pause.resume', this.onResume);
    },
    onVisibilityChange(){
      if(document.hidden){
        this.startEvent('invisible');
      }else{
        this.startEvent('visible');
      }
    },
    onBlur(){
      this.startEvent('background');
    },
    onFocus(){
      this.startEvent('foreground');
    },
    onResize(){
      if(this.timeoutRef){
        clearTimeout(this.timeoutRef);
      }
      this.timeoutRef = setTimeout(this.afterResize, 1000);
    },
    onPause(){
      this.startEvent('paused');
    },
    onResume(){
      this.startEvent('resumed');
    },
    afterResize(eventname='resize'){
      this.currentPageState=eventname;
      this.stateStarted=moment.utc().valueOf();
      this.stopEvent();
    },
    clearListeners(){
      document.removeEventListener("visibilitychange",this.onVisibilityChange);
      window.removeEventListener("blur",this.onBlur);
      window.removeEventListener("focus",this.onFocus);
      window.removeEventListener("resize",this.onResize);
      applicationEventHub.$off('framework.pause.start', this.onPause);
      applicationEventHub.$off('framework.pause.resume', this.onResume);
    },
    startEvent(eventname){
      if((!this.currentPageState && (eventname==='invisible' || eventname==='background' || eventname==='paused')) || (this.currentPageState==='background' && eventname==='invisible')){
        this.currentPageState=eventname;
        this.stateStarted=moment.utc().valueOf();
      }else if(this.currentPageState && (eventname==='foreground' || eventname==='visible' || eventname==='resumed')){
        this.stopEvent();
      }

    },
    stopEvent(){
      this.stateEnded=moment.utc().valueOf();

      let percWidth=window.innerWidth/window.screen.availWidth;
      let percHeight = window.innerHeight/window.screen.availHeight;

      let assessmentmeasureid;
      let journeyresponseid;
      if(this.$store.state.assessment){
        if(this.$store.state.assessment.assessmentmeasure){
          assessmentmeasureid=this.$store.state.assessment.assessmentmeasure.assessmentmeasureid;
        }

        if(this.$store.state.assessment.journeyplan &&  this.$store.state.assessment.journeyplan.journeyresponses && this.$store.state.assessment.currentQuestionIndex!==null && this.$store.state.assessment.journeyplan.journeyresponses[this.$store.state.assessment.currentQuestionIndex]){
          journeyresponseid=this.$store.state.assessment.journeyplan.journeyresponses[this.$store.state.assessment.currentQuestionIndex].journeyresponseid;
        }
      }

      let data = {
        event : this.currentPageState,
        started : this.stateStarted,
        ended : this.stateEnded,
        width_cover : percWidth,
        height_cover : percHeight,
        assessmentmeasureid:assessmentmeasureid,
        journeyresponseid:journeyresponseid
      };

      this.$store.dispatch('assessment/saveAuditLogEntry',data);

      this.currentPageState=null;
      this.stateStarted=null;
      this.stateEnded=null;
    }
  },
  beforeDestroy(){
    this.clearListeners();
    if(this.currentPageState){
      this.stopEvent();
    }
  },
  mounted() {
    this.afterResize('loaded');
    this.initPageChecks();
  }
}